// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7856) return "static/chunks/7856-01e275f92d9fda82.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"5443":"669ee4eb0ffa8e1c","6350":"a186977c779a41e7","7287":"07b65114e12a7d7e"}[chunkId] + ".js";
};